module.exports = __webpack_public_path__ + "static/media/energy power.d54de644.jpg";